import { useEffect, useState } from "react";
import { ReleaseDetailsBody, ReleaseDetailsPageHeader } from "./components";
import { useUser } from "@hooks/useUser";
import { useRelease } from "@hooks/HRM/employees/useRelease";
import { useLocation, useParams } from "react-router-dom";
import { STATUS } from "@constants/status.hrm";

const { DRAFT, IN_PROGRESS } = STATUS;

const ReleaseDetails = () => {
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [showActionButton, setShowActionButton] = useState<boolean>(false);
  const [showApprovalButton, setShowApprovalButton] = useState<boolean>(false);

  const { id } = useParams();
  let { pathname } = useLocation();

  const isCreatePage = pathname.includes("create");

  const {
    user: { employeeMasterId, realm_roles: roles },
  } = useUser();
  const releaseData = useRelease(id as any, isCreatePage);
  const canUpdateRelease = roles.includes("f_per_all_release");

  useEffect(() => {
    setIsDisabled(
      !(releaseData.status === DRAFT && canUpdateRelease) && !isCreatePage,
    );
    setShowActionButton(
      Number(releaseData?.reviewer?.id) === Number(employeeMasterId) &&
        releaseData.status === IN_PROGRESS,
    );
    setShowApprovalButton(
      canUpdateRelease && releaseData.id && releaseData.status === DRAFT
        ? true
        : false,
    );
  }, [releaseData, employeeMasterId]);

  return (
    <>
      {isCreatePage && <ReleaseDetailsPageHeader />}
      <ReleaseDetailsBody
        isDisabled={isDisabled}
        isCreatePage={isCreatePage}
        releaseData={releaseData}
        showActionButton={showActionButton}
        showApprovalButton={showApprovalButton}
        employeeMasterId={employeeMasterId}
      />
    </>
  );
};

export default ReleaseDetails;
